/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_SubInputs */

const en_vc_status_sub = /** @type {(inputs: Vc_Status_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft is alpha software that is moving fast. Here is an honest picture of what works and what is still missing.`)
};

const zh_vc_status_sub = /** @type {(inputs: Vc_Status_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 还处于 alpha 阶段，更新很快。下面如实说明哪些已经能用、哪些还没有。`)
};

/**
* | output |
* | --- |
* | "VectorCraft is alpha software that is moving fast. Here is an honest picture of what works and what is still missing." |
*
* @param {Vc_Status_SubInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_sub = /** @type {((inputs?: Vc_Status_SubInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_SubInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_sub(inputs)
	return zh_vc_status_sub(inputs)
});
export { vc_status_sub as "vc.status.sub" }